import { useEffect, useState } from 'react'

import ClientLogger from './client-logger'

const useClientLogger = () => {
  const [clientLogger, setClientLogger] = useState<ClientLogger | null>(null)

  useEffect(() => {
    if (!window.Rollbar || clientLogger) return
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const rollbar = new ClientLogger(window.Rollbar)
    setClientLogger(rollbar)
  }, [])

  return clientLogger
}

export default useClientLogger
